<template>
  <el-dialog title="提示" :visible.sync="visible" width="800px" @close="onClose">
    <el-form ref="form" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="质检图片" prop="files">
        <c-file-upload :limit="9" :image="true" :isShowTip="false" v-model="form['files']"></c-file-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
export default {
  data() {
    return {
      visible: false,
      form: {
        booking_id: "",
        files: []
      },
      rules: {
        files: [
          { required: true, message: "请上传质检图片", trigger: "change" }
        ]
      }
    }
  },
  methods: {
    onOpen(detail) {
      this.form.booking_id = detail.id;
      this.form.files = cloneDeep(detail.inspection_files) || [];
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    onClose() {
      this.form = {
        booking_id: "",
        files: []
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    onConfirm() {
      this.$refs.form.validate(async (v) => {
        if (v) {
          try {
            await this.$common.http({
              url: "/api/queue/admin/update_queue_file",
              data: this.form
            });
            this.$emit("ok");
            this.visible = false;
          } catch (error) {}
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>